import { useEffect } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import "./ProductPage.scss";
import backgroundImage from "../../../assets/resultpage_bg.png";
import { MoreInfo } from "./MoreInfo/MoreInfo";
import productsInfo from "../../../data/productsInfo.json";

export const ProductPage = ({
  aiResults,
  recommendedData,
  onBackClick,
  onExitClick,
  onBuyClick,
}) => {
  const { t } = useTranslation("productModule");
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  const filteredProducts = recommendedData.recommendations ?? [];

  useEffect(() => {
    trackEvent("webapp_user_visited_products_page", uid);
  }, [uid, trackEvent]);

  return (
    <div
      className="products-page"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
      }}
    >
      <div className="products-page-top-container">
        <div className="products-page-back-button-wrapper">
          <div className="back-icon" onClick={() => onBackClick()}>
            <IoChevronBackOutline />
          </div>
        </div>
        <div className="products-page-top-header">
          <p>Products Made for</p>
          <p>Your Hair!</p>
        </div>
        <div className="products-page-close-button-wrapper">
          <div className="close-icon" onClick={onExitClick}>
            <IoCloseOutline />
          </div>
        </div>
      </div>
      <div className="products-page-results-slider">
        {Object.entries(aiResults).map(([aiCategory, aiResult]) => (
          <div key={aiCategory} className="result-box">
            <h4 className="result-box-category">
              {t(aiCategory, { ns: "aiResults" })}:
            </h4>
            <h4 className="result-box-value">
              {t(aiResult.value, { ns: "aiResults" })}
            </h4>
          </div>
        ))}
      </div>
      <div className="products-page-white-area">
        <img
          className="products-page-background-image"
          src="images/curl-yellow.png"
          alt="Yellow Curl"
          width={100}
        />
        <div className="products-page-main-content">
          <p className="products-page-main-title">
            Discover care specially developed for your hair.
          </p>
          {filteredProducts.length > 0 ? (
            <>
              <h4 className="products-page-recommend-text">Your Top Pick!</h4>
              <div className="product-page-main-product">
                <div className="main-product-card">
                  <div className="main-product-image-container">
                    <img
                      className="main-product-image"
                      src={`data:image/png;base64, ${filteredProducts[0].image}`}
                      alt="Main Product"
                      width={100}
                    />
                  </div>
                  <div className="main-product-info-container">
                    <p className="main-product-brand-text">
                      {filteredProducts[0].brand}
                    </p>
                    <p className="main-product-name-text">
                      {filteredProducts[0].name}
                    </p>
                  </div>
                </div>
                <div className="main-product-description-containers">
                  <div className="divider-line" />
                  <MoreInfo
                    title={"DESCRIPTION"}
                    text={
                      productsInfo[filteredProducts[0].name]?.description ?? ""
                    }
                  />
                  <div className="divider-line" />
                  <MoreInfo
                    title={"HOW TO USE"}
                    text={
                      productsInfo[filteredProducts[0].name]?.howToUse ?? ""
                    }
                  />
                  <div className="divider-line" />
                </div>
              </div>
            </>
          ) : (
            <div className="not-found-container">
              <h4 className="not-found-header">{t("not-found-header")}</h4>
              <p className="not-found-text">{t("not-found-text")}</p>
            </div>
          )}
          {filteredProducts.length > 1 && (
            <>
              <h4 className="products-page-recommend-text">
                You might also like:
              </h4>
              <div className="products-page-items-wrapper">
                {filteredProducts.slice(1, 4).map((product, index) => (
                  <div key={index} className="secondary-product-card">
                    <div className="secondary-product-image-container">
                      <img
                        src={`data:image/png;base64, ${product.image}`}
                        alt={product.name}
                        width={100}
                        className="secondary-product-card-image"
                      />
                    </div>
                    <div className="secondary-product-card-info-container">
                      <p className="secondary-product-brand-text">
                        {product.brand}
                      </p>
                      <p className="secondary-product-name-text">
                        {product.name}
                      </p>
                    </div>
                    <div className="secondary-product-description-containers">
                      <div className="divider-line" />
                      <MoreInfo
                        title={"DESCRIPTION"}
                        text={productsInfo[product.name]?.description ?? ""}
                      />
                      <div className="divider-line" />
                      <MoreInfo
                        title={"HOW TO USE"}
                        text={productsInfo[product.name]?.howToUse ?? ""}
                      />
                      <div className="divider-line" />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="products-page-bottom-button">
          <button className="product-buy-button" onClick={onBuyClick}>
            Buy Products
          </button>
        </div>
      </div>
    </div>
  );
};
